import { render, staticRenderFns } from "./JAEG.vue?vue&type=template&id=bda2bb46&"
import script from "./JAEG.vue?vue&type=script&lang=js&"
export * from "./JAEG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports